var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-scroll-lock', {
    attrs: {
      "eager": "",
      "width": "400",
      "persistent": _vm.saveStatus.pending,
      "value": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('error-dialog', {
    attrs: {
      "status": _vm.saveStatus
    }
  }), _c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": "",
      "disabled": _vm.saveStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm._v("Add card")]), _c('div', {
    staticClass: "px-4 pt-6 pb-4"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "label": "Description (optional)"
    },
    model: {
      value: _vm.description,
      callback: function ($$v) {
        _vm.description = $$v;
      },
      expression: "description"
    }
  }), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "outlined": "",
      "readonly": "",
      "label": "Card",
      "value": " ",
      "error": !!_vm.cardError,
      "error-messages": _vm.cardError ? [_vm.cardError] : [],
      "loading": _vm.loadStripeCardElementStatus.pending
    }
  }), _c('div', {
    ref: "card-element",
    staticClass: "mx-3 mt-3",
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "left": "0",
      "right": "0"
    }
  })], 1), _c('div', {
    attrs: {
      "id": "card-errors",
      "role": "alert"
    }
  }), _c('div', {
    staticClass: "mt-1 text-center"
  }, [_c('img', {
    staticClass: "d-inline-block",
    attrs: {
      "width": "120",
      "src": require("../assets/credit-cards-448.png")
    }
  })])], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "disabled": _vm.saveStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('input', false);
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.isCardComplete,
      "loading": _vm.saveStatus.pending
    },
    on: {
      "click": function ($event) {
        return _vm.save({
          card: _vm.card
        }, _vm.description);
      }
    }
  }, [_vm._v(" Save card ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }